// extracted by mini-css-extract-plugin
export default {"TextButton":"TextButton_TextButton__wq5Tb"};